module.exports = __webpack_public_path__ + "img/AbdallahElgamil.84415a69.jpg";